import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /* align-items: stretch; */
`;

export const SubContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  ${({ loggedIn }) => {
    if (!loggedIn) {
      return "justify-content: center";
    }
  }}
`;
